var map = {
	"./BlockElement": 2981,
	"./BlockElement/": 2981,
	"./BlockElement/index": 2981,
	"./BlockElement/index.tsx": 2981,
	"./BlockElement/styles": 12989,
	"./BlockElement/styles.ts": 12989,
	"./CentredLoader": 61458,
	"./CentredLoader/": 61458,
	"./CentredLoader/index": 61458,
	"./CentredLoader/index.tsx": 61458,
	"./ConfirmationPopups": 99366,
	"./ConfirmationPopups/": 99366,
	"./ConfirmationPopups/index": 99366,
	"./ConfirmationPopups/index.tsx": 99366,
	"./FileDownloadButton": 50846,
	"./FileDownloadButton/": 50846,
	"./FileDownloadButton/index": 50846,
	"./FileDownloadButton/index.tsx": 50846,
	"./MilkdownEditor": 40631,
	"./MilkdownEditor.tsx": 40631,
	"./Template": 79810,
	"./Template/": 79810,
	"./Template/index": 79810,
	"./Template/index.tsx": 79810,
	"./Toggle": 96188,
	"./Toggle/": 96188,
	"./Toggle/index": 96188,
	"./Toggle/index.tsx": 96188,
	"./Toggle/styles": 17488,
	"./Toggle/styles.ts": 17488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86900;